import React, { useState } from "react";
import { Modal, Box, IconButton } from "@mui/material";
import { XMarkIcon, XCircleIcon } from "@heroicons/react/24/outline";

export default function ImagePreviewModal({ imageUrl, open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          outline: "none",
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8, color: "#fff" }}
        >
          <XCircleIcon className="w-8 h-8" aria-hidden="true" />
        </IconButton>

        {/* Image */}
        <img
          src={imageUrl}
          alt="Preview"
          style={{
            maxWidth: "1100vw",
            maxHeight: "80vh",
            display: "block",
            borderRadius: "8px",
          }}
        />
      </Box>
    </Modal>
  );
}